import React from "react";
import { useLocation } from "react-router";
import { Paragraph } from "@tvg/design-system";
import { useColorTokens } from "@tvg/design-system/web/hooks";
import { buildQaLabel } from "@tvg/test-utils/utils";
import type { Props } from "./types";
import { Container } from "./styled-components";
import { renderIcon } from "./renderer";
import { CONTAINER, ITEM, TEXT } from "../../constants";

const NavigationBarItem = ({ item, qaLabel = "" }: Props) => {
  const colorTokens = useColorTokens();
  const { pathname } = useLocation();

  // Fallback for when we land in "/" (results in ["", ""] )
  const shortPathname = pathname.split("/")[1] || "home";
  const isActive = item.href.replace("/", "") === shortPathname;
  const color = isActive
    ? colorTokens.content.link
    : colorTokens.content.default;

  return (
    <Container
      to={item.to}
      onClick={item.onClick}
      data-qa-label={buildQaLabel([qaLabel, ITEM, CONTAINER, item.key])}
    >
      {renderIcon(item, color, qaLabel)}

      <Paragraph
        qaLabel={buildQaLabel([qaLabel, ITEM, TEXT])}
        color={color}
        fontFamily="regular"
        fontSize={10}
        lineHeight="125%"
      >
        <>{item.name}</>
      </Paragraph>
    </Container>
  );
};

export default NavigationBarItem;
